var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-wrap"},[_c('div',{ref:"chartRef",staticClass:"chart-container",style:({ width: '100%', height: '67vh' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }